import { renderBootstrapFailure } from '@/lib/bootstrapFailure';
import { registerVitePreloadErrorUpdateCheck } from '@/lib/spaUpdate';
import { configureValidationRuntime } from '@/lib/validationRuntime';

import './index.css';

// Static imports are evaluated before this module body. Configure Zod first, then load
// the application dynamically so no schema can trigger its Function() capability probe.
configureValidationRuntime();
registerVitePreloadErrorUpdateCheck();

void import('./bootstrap').catch(renderBootstrapFailure);

// The integration and local builds can preview RC003 limit states without changing server data.
// This dynamic module is omitted from production builds.
if (
  import.meta.env.MODE === 'development' ||
  import.meta.env.VITE_SENTRY_ENVIRONMENT === 'integration'
) {
  void import('./testing/rc003Preview').then(({ installRc003Preview }) => installRc003Preview());
}
